/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { BehaviorSubject, Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { fromFirebaseRef } from '../services/rxjs-internal-extensions';

import * as moment from 'moment';
import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';

import firebase from 'firebase/compat/app';

export const dateFormat = 'YYYY-MM-DD';
export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ssZZ';

export class FbdbTime {
	public get dateFormat() {
		return dateFormat;
	}
	public get dateTimeFormat() {
		return dateTimeFormat;
	}

	private subscriptions: Subscription[] = [];
	private time$ = new BehaviorSubject<string>(fallbackTime());

	public timeStream$ = this.time$.asObservable();

	public get syncTime() {
		return this.time$.getValue();
	}
	public get syncMoment() {
		return moment(this.time$.getValue(), dateTimeFormat, false);
	}

	public start() {
		const fbdbStatsPath = fancyFirebaseGetters.getFbdbStatsPath();
		const timestampRef = fancyFirebaseReferencer
			.getLegacyRef<firebase.database.Reference>(fbdbStatsPath)
			.child('server_time_view')
			.child('0')
			.child('fbdb_current_timestamp');
		const obs = fromFirebaseRef('value', timestampRef).pipe(
			filter((thing) => thing.exists()), //just in case the db isn't loaded or something
			map((thing) => thing.val())
		);

		this.subscriptions.push(obs.subscribe(this.time$));
	}

	public destroy() {
		this.subscriptions.forEach((t) => t.unsubscribe());
	}
}
export const fbdbTime = new FbdbTime();

/** returns the client time in the server time format */
function fallbackTime() {
	return moment().format(dateTimeFormat);
}
